import { watch, type Ref } from 'vue'
import type { PublicStore } from '~/services/api/stores/interfaces'

// Replacing loads settle on a store, an error, or an empty slug; caller cancellation stops observation.
export const waitForStoreContext = (
  store: Readonly<Ref<PublicStore | null>>,
  error: Readonly<Ref<string | null>>,
  slug: Readonly<Ref<string>>,
  signal: AbortSignal
): Promise<boolean> =>
  new Promise((resolve) => {
    if (signal.aborted) {
      resolve(false)
      return
    }
    const settled = (): boolean => store.value !== null || error.value !== null || slug.value === ''
    if (settled()) {
      resolve(true)
      return
    }
    const stop = watch([store, error, slug], () => {
      if (settled()) finish(true)
    })
    const finish = (ready: boolean): void => {
      stop()
      signal.removeEventListener('abort', cancel)
      resolve(ready)
    }
    const cancel = (): void => {
      finish(false)
    }
    signal.addEventListener('abort', cancel, { once: true })
    if (signal.aborted) cancel()
  })
